import React from 'react';

import type { PartnerType } from '../../api/partners';

// v9 monogram colors per partner type (PCOLOR in the prototype), mapped to theme classes.
const MONOGRAM_CLASSES: Record<PartnerType, string> = {
	bank: 'bg-primary-50 text-primary-500',
	pos_dealer: 'bg-green-50 text-green-700',
	cpa_firm: 'bg-sand-100 text-sand-900',
	software: 'bg-primary-100 text-primary-700',
	direct: 'bg-gray-100 text-primary-500',
};

export const initials = (name: string) =>
	name
		.replace(/&/g, '')
		.split(/\s+/)
		.filter((word) => /^[A-Za-z]/.test(word))
		.slice(0, 2)
		.map((word) => word[0].toUpperCase())
		.join('');

interface PartnerLogoProps {
	partner: {
		name: string;
		partner_type: PartnerType;
		logo_data_url: string | null;
	};
	large?: boolean;
}

const PartnerLogo: React.FC<PartnerLogoProps> = ({ partner, large }) => {
	const box = large
		? 'w-[88px] h-[88px] rounded-[12px] text-[32px]'
		: 'w-8 h-8 rounded-lg text-xs';
	if (partner.logo_data_url) {
		return (
			<img
				src={partner.logo_data_url}
				alt=""
				className={`${box} object-contain bg-white border border-gray-200 flex-none`}
			/>
		);
	}
	return (
		<span
			aria-hidden="true"
			className={`${box} ${MONOGRAM_CLASSES[partner.partner_type]} border border-gray-200 flex-none inline-flex items-center justify-center font-bold`}
		>
			{initials(partner.name || 'New partner')}
		</span>
	);
};

export default PartnerLogo;
